<template src='./annulledMovements.pug' lang='pug'></template>

<script>
import moment from 'moment'
import MultiSelectModal from '../../modals/multiSelectModal/MultiSelectModal'
import DateRange from '../../input/dateRange/DateRange'
import BetterInputTag from '../../input/betterInputTag/BetterInputTag'
import ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'
import language from '../../../../build/language/index'

export default {
  name: 'DuplicateMovements',

  components: {
    MultiSelectModal,
    DateRange,
    BetterInputTag,
    ButtonPrimary
  },

  props: {
    disableSearchButton: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      language: language,
      dateRange: {},
      firstDate: new Date(),
      finalDate: new Date(),
      finalDateDisable: moment(new Date()).add(10, 'years').toDate(),
      inputTagsProps: {
        bankAccounts: {
          id: 'id',
          name: 'nome'
        }
      },
      shown: {
        bankAccounts: false
      },
      defaultTags: {
        bankAccounts: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todos')
        }]
      },
      data: {
        bankAccounts: {
          titles: {
            main: this.$t('analiseDuplicidade.labels.contasBancarias'),
            sub: this.$t('analiseDuplicidade.labels.selecionarContasBancarias')
          },
          allBankAccounts: [],
          showToggleInactiveAccounts: false,
          selectedItems: [],
          considerInactiveAccounts: false,
          columns: ['nome', 'banco', 'numAgencia', 'conta'],
          values: [],
          options: {
            columnsClasses: { nome: 'col-md-3', banco: 'col-md-4', numAgencia: 'col-md-2', conta: 'col-md-3' },
            perPage: 5,
            headings: {
              nome: this.$t('contaBancaria.labels.nome'),
              banco: this.$t('contaBancaria.labels.banco'),
              numAgencia: this.$t('contaBancaria.labels.agencia'),
              conta: this.$t('contaBancaria.labels.numeroConta')
            },
            filterable: ['nome', 'banco', 'numAgencia', 'conta'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['nome', 'banco', 'numAgencia', 'conta'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'nome'
            },
            customSorting: {
              nome: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase())
                  }
                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase())
                }
              },
              banco: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.banco.codigo <= b.banco.codigo ? 1 : -1
                  }
                  return a.banco.codigo >= b.banco.codigo ? 1 : -1
                }
              },
              agencia: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.numAgencia <= b.numAgencia
                  }
                  return a.numAgencia >= b.numAgencia
                }
              },
              conta: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return +a.conta >= +b.conta ? 1 : -1
                  }
                  return +a.conta <= +b.conta ? 1 : -1
                }
              }
            },
            templates: {
              nome: (h, row) => {
                let txt = row.nome
                if (!row.ativo) {
                  txt += ' (' + this.$t('contaBancaria.labels.inativa') + ')'
                }
                return txt
              },
              banco: (h, row) => {
                if (row.banco) {
                  return row.banco.codigo + '-' + row.banco.nome
                }
                return '-'
              },
              agencia: (h, row) => {
                let txt = '-'
                if (row.agencia) {
                  txt = row.numAgencia
                  if (row.digAgencia) {
                    txt += '-' + row.digAgencia
                  }
                }
                return txt
              },
              conta: (h, row) => {
                let txt = row.conta
                if (row.digConta) {
                  txt += '-' + row.digConta
                }
                return txt
              }
            }
          }
        }
      }
    }
  },

  methods: {
    openSelectBankAccountsModal () {
      if (this.data.bankAccounts.values.length > 0) {
        this.shown.bankAccounts = true
        return
      }
      this.$store.dispatch('getBankAccounts', '/bankStatement/bankAccounts/list')
        .then(response => {
          this.data.bankAccounts.allBankAccounts = response.data.data
          this.data.bankAccounts.showToggleInactiveAccounts = this.data.bankAccounts.allBankAccounts.find((bankAccount) => {
            return !bankAccount.ativo
          })
          this.data.bankAccounts.values = this.data.bankAccounts.allBankAccounts.filter((bankAccount) => {
            return bankAccount.ativo
          })
          this.shown.bankAccounts = true
        })
    },

    closeModal () {
      this.shown.bankAccounts = false
    },

    validate () {
      const self = this
      this.$validator.validateAll().then((result) => {
        if (result && self.$refs.dateRange.validate()) {
          const searchData = {
            gridId: 'LancamentoAnulado',
            actionName: 'searchAnnulledMovements',
            filter: {
              inicio: self.dateRange.fromDate,
              fim: self.dateRange.toDate,
              idsConta: self.data.bankAccounts.selectedItems.map(selected => selected.id).filter(account => account !== '-1'),
              lang: language.getCookieByName('language')
            }
          }

          this.$emit('search-movements', searchData)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// AnnulledMovements.vue?7c64d9b1